import { Field, InputType, ObjectType } from 'type-graphql'

@ObjectType({
  description: 'Represents a key item that defines the categorization structure for data organization and search.'
})
export class DataKeyItem {
  @Field({ description: 'Name of the key item for identification.' })
  name: string

  @Field({ nullable: true, description: 'Description of the key item.' })
  description?: string

  @Field({ nullable: true, description: 'The data key used for categorization and indexing.' })
  dataKey: string

  @Field({ nullable: true, description: 'The template key for data organization.' })
  tKey?: string
}

@InputType()
export class DataKeyItemPatch {
  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true, description: 'Description of the key item.' })
  description?: string

  @Field({ nullable: true, description: 'The data key used for categorization and indexing.' })
  dataKey?: string

  @Field({ nullable: true, description: 'The template key for data organization.' })
  tKey?: string
}
